import Cookies from 'js-cookie';
import { getEnv } from './utilities/env';

export const setCookiesSession = (cookieName, authToken, expiryTime) => {
  // const secondsInMinute = expiryTime / 60;
  // const in120Minutes = secondsInMinute / 1440;
  Cookies.set(cookieName, authToken, {
    expires: expiryTime,
    domain: getEnv('REACT_APP_COOKIE_DOMAIN'),
  });
};

export const deleteCookie = (cookieName) => {
  Cookies.remove(cookieName, { domain: getEnv('REACT_APP_COOKIE_DOMAIN') });
};
export const getCookiesSession = (cookieName) => Cookies.get(cookieName);
